import React from 'react'
import Reactportal from '../../Components/Reactportal/Reactportal';
import PortalFooter from '../../Components/Reactportal/PortalFooter';
import { RiErrorWarningFill } from 'react-icons/ri';

const DeleteBoard = ({toggle,settoggle,handleClick,DeleteLoad, text="Board"}) => {
    return (
        <Reactportal
          open={toggle}
          onClose={() => settoggle(false)}
          TypeOfPortal={"Confirm"}
          //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
        >
          <div className="warning">
            <RiErrorWarningFill className="warningIcon" />
            <p className="warningMsg">Are You Sure You Want to Delete this {text} ?</p>
          </div>
  
          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitform={handleClick}
            submitType={"Confirm Delete"}
            handleformclose={() => {
              settoggle(!toggle);
            }}
            loadingState={DeleteLoad}
          />
        </Reactportal>
      );
}

export default DeleteBoard
